import { create } from 'zustand';

/**
 * Unit Store - Pure State Management
 * Rule: NO API IN STORE - Only state mutations
 * API calls are handled by UnitIntegration
 */
const useUnitStore = create((set) => ({
  // State
  units: [],
  unitsForDropdown: [],
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  loading: false,
  error: null,
  selectedUnit: null,
  isEditing: false,
  isCreating: false,
  lastUpdated: null,

  // Pure State Mutations - NO API CALLS
  setUnits: (units) => set({
    units,
    lastUpdated: new Date().toISOString()
  }),

  setUnitsForDropdown: (unitsForDropdown) => set({ unitsForDropdown }),

  setPaginationData: (paginationData) => set({ paginationData }),

  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setColumnFilters: (columnFilters) => set({ columnFilters }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  clearError: () => set({ error: null }),

  // UI Actions
  startCreating: () => set({
    isCreating: true,
    isEditing: false,
    selectedUnit: null
  }),

  startEditing: (unit) => set({
    isEditing: true,
    isCreating: false,
    selectedUnit: unit
  }),

  cancelEditing: () => set({
    isEditing: false,
    isCreating: false,
    selectedUnit: null
  }),

  setSelectedUnit: (unit) => set({
    selectedUnit: unit
  }),

  reset: () => set({
    units: [],
    unitsForDropdown: [],
    columnFilters: {},
    uniqueValues: {},
    paginationData: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
      hasNextPage: false,
      hasPreviousPage: false,
    },
    loading: false,
    error: null,
    selectedUnit: null,
    isEditing: false,
    isCreating: false,
    lastUpdated: null,
  }),
}));

export { useUnitStore };
